module.exports = __webpack_public_path__ + "static/media/milestone-1-2.3ae72410.png";